import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import IntlMessages from 'util/IntlMessages';

const PopularQueries = ({ maxQueries = 10, maxItems = 10, hidden, ...props }) => {
  if (hidden) return null;

  const maxToShow = maxQueries || maxItems;

  return (
    <Box display="flex" flexWrap="wrap" gap={1} {...props}>
      {Array.from({ length: Math.min(maxToShow, 8) }).map((_, i) => (
        <Box
          // eslint-disable-next-line react/no-array-index-key
          key={`popular-${i}`}
          px={2}
          py={0.5}
          bgcolor="#fff3e0"
          border="1px solid #ffb74d"
          borderRadius={2}
        >
          <Typography variant="caption" style={{ opacity: 0 }}>
            <IntlMessages id="ui.searchExperienceV2.core.blocks.popularQueries.popular" />
            {' '}
            {i + 1}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

PopularQueries.propTypes = {
  maxQueries: PropTypes.number,
  maxItems: PropTypes.number,
};

export default PopularQueries;
